import styled from 'styled-components';

import { StyleColor } from '../../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../../utils/style';

interface WrapperProps {
	isError: boolean;
}

interface InnerProps {
	width: number;
	isError: boolean;
}

const Wrapper = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	border: 1px solid currentColor;
	border-radius: inherit;
	background-color: ${StyleColor.Grey700};
	color: ${({ isError }: WrapperProps) => isError ? StyleColor.Red : StyleColor.White};
	text-align: center;
	line-height: 36px;
	overflow: hidden;
`;

const Inner = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: ${({ width }: InnerProps) => `${width}%`};
	border-radius: inherit;
	background-color: ${({ isError }: InnerProps) => isError ? 'transparent' : hexToRgba(StyleColor.White, 50)};
	transition: width 0.1s ease-in;
`;

const Label = styled('div')`
	position: relative;
	z-index: 1;
`;

export {
	Wrapper,
	Inner,
	Label,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/ProgressBar/styles.ts